// Import Hook modules
import bulkImport from "./bulk_import";
import kanbanDnd from "./kanban_drag_and_drop";

const Hooks = {};

// ES6 Debounce function
// https://dev.to/monaye/refactor-davidwalsh-s-debounce-function-5afc
// TODO: Should we move this somewhere more global?
const debounce = (func, delay) => {
  let timerId;
  return (...args) => {
    const boundFunc = func.bind(null, ...args);
    clearTimeout(timerId);
    timerId = setTimeout(boundFunc, delay);
  };
};

// Only send to server once for multiple events
const doTagUpdate = debounce((lv, leadId, tags) => {
  // Send event to server
  lv.pushEvent("update-tags", {
    lead_id: leadId,
    tags,
  });
}, 1000);

Hooks.RecruitmentTags = {
  mounted() {
    window.recruitmentTags = this;
    this.tags = "";
  },

  updateTags(leadId, tags) {
    // Convert list to semi-colon separated string
    this.tags = tags.join(";");

    if (leadId) {
      doTagUpdate(this, leadId, this.tags);
    }
  },
};

Hooks.RecruitmentReportingCard = {
  mounted() {
    // If Card is not selectable, ignore this call
    if (!this.el.classList.contains("is-selectable")) {
      return;
    }

    // When a Card is clicked/selected, highlight it
    this.el.addEventListener("click", (e) => {
      // If options menu dropdown is clicked, don't do anything
      if (e.target.closest(".dropdown")) {
        return;
      }

      // Give immediate feedback to user while we wait for a server response
      this.el.classList.toggle("is-selected");
      this.el
        .querySelector(".icon.is-selectable")
        .classList.toggle("is-selected");

      const { contactId } = this.el.dataset;

      // Send event to server
      this.pushEvent("select-toggle", { contact_id: contactId });
    });
  },
};

Hooks.RecruitmentConfirmReport = {
  mounted() {
    // When the "Select All" checkbox is toggled, either highlight all Contact Cards or none
    this.el.addEventListener("click", () => {
      // Give immediate feedback to user while we wait for a server response
      document.querySelector("#list-prospects").classList.toggle("is-hidden");
      document.querySelector("#confirm-report").classList.toggle("is-hidden");

      // Send event to server
      this.pushEvent("confirm-toggle");
    });
  },
};

export default {
  ...Hooks,
  ...bulkImport,
  ...kanbanDnd,
};
